export const testimonialsText = {
  en: {
    sectionTitle: "How I Support You",
    cards: [
      {
        quote: "What I Offer",
        title: "Career Counselling (1:1)",
        items: [
          "Discover your personality profile",
          "Clarify your core values and priorities",
          "Build a personalised career roadmap",
          "Identify the fields that best fit you",
          "Get support with career transitions or returning to work",
        ],
        photo: "/images/tb16.jpg",
      },
      {
        quote: "Why Work With Me",
        title: "If you're looking for someone who is:",
        items: [
          "Empathetic and understanding",
          "Non-judgmental and warm",
          "Aware of Asian cultural expectations",
          "Understanding of motherhood pressures",
          "Experienced as an immigrant starting over",
          "Someone who has navigated many career detours personally",
        ],
        photo: "/images/tb6.jpg",
      },
    ],
  },

  vi: {
    sectionTitle: "Tôi Đồng Hành Cùng Bạn Như Thế Nào",
    cards: [
      {
        quote: "Tôi Mang Đến Điều Gì",
        title: "Tư Vấn Nghề Nghiệp 1:1",
        items: [
          "Khám phá hồ sơ tính cách cá nhân",
          "Làm rõ giá trị cốt lõi và ưu tiên cuộc sống",
          "Xây dựng lộ trình nghề nghiệp phù hợp với bạn",
          "Xác định lĩnh vực công việc phù hợp nhất",
          "Hỗ trợ chuyển hướng nghề nghiệp hoặc quay lại làm việc",
        ],
        photo: "/images/tb16.jpg",
      },
      {
        quote: "Vì Sao Nên Đồng Hành Cùng Tôi",
        title: "Nếu bạn đang tìm một người:",
        items: [
          "Biết lắng nghe và thấu cảm",
          "Không phán xét, luôn ấm áp",
          "Hiểu rõ kỳ vọng văn hoá Á Đông",
          "Thấu hiểu áp lực của người làm mẹ",
          "Từng là người nhập cư bắt đầu lại từ đầu",
          "Đã trải qua nhiều ngã rẽ nghề nghiệp trong đời",
        ],
        photo: "/images/tb6.jpg",
      },
    ],
  },
};
